export { LightningBolt as default } from './LightningBolt';
